// Gives screens the API client, a way to leave the app (to Google or the
// meeting) and a random source, so tests can replace all three.
import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from './api-client';

interface ApiContextValue {
  client: ApiClient;
  navigateAway: (url: string) => void;
  random: () => number;
}

const ApiContext = createContext<ApiContextValue | null>(null);

export function ApiProvider(props: ApiContextValue & { children: ReactNode }) {
  const { children, ...value } = props;
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

function useApiContext(): ApiContextValue {
  const value = useContext(ApiContext);
  if (!value) throw new Error('ApiProvider is missing');
  return value;
}

export const useApi = () => useApiContext().client;
export const useNavigateAway = () => useApiContext().navigateAway;
export const useRandom = () => useApiContext().random;
